<template>
    <div class="w-full md:grid md:grid-cols-2 md:gap-6">
        <div class="flex flex-col">
            <div>
                <label class="ml-1 text-sm">
                    <input
                        v-model="studentAttendanceDetail.absent"
                        name="absent[]"
                        :disabled="studentAttendanceDetail.delayed"
                        type="checkbox"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                    {{ $t('messages.absent') }}
                </label>
            </div>
            <div class="mt-1 rounded-md shadow-sm" v-if="studentAttendanceDetail.absent">
                <FormSelect
                    id="justification"
                    :name="'justification[' + studentAttendanceDetail.student_id + ']'"
                    v-model="studentAttendanceDetail.justification"
                    :options="justifications"
                    class="mt-1 w-full"
                />
            </div>
        </div>
        <div class="flex flex-col">
            <div>
                <label class="ml-1 text-sm">
                    <input
                        v-model="studentAttendanceDetail.delayed"
                        name="delayed[]"
                        :disabled="studentAttendanceDetail.absent"
                        type="checkbox"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                    {{ $t('messages.delay') }}
                </label>
            </div>
            <div class="mt-1 rounded-md shadow-sm" v-if="studentAttendanceDetail.delayed">
                <FormSelect
                    id="delay"
                    :name="'delay[' + studentAttendanceDetail.student_id + ']'"
                    v-model="studentAttendanceDetail.delay"
                    :options="delays"
                    class="mt-1 w-full"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StudentAttendanceDetailForm',
};
</script>
<script setup>
import { useVModel } from '@vueuse/core';
import { watch } from 'vue';
import FormSelect from '@/components/Forms/FormSelect.vue';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    delays: {
        type: Array,
        required: true,
    },
    justifications: {
        type: Array,
        required: true,
    },
});
let emit = defineEmits(['update:modelValue']);
const studentAttendanceDetail = useVModel(props, 'modelValue', emit);

watch(
    () => studentAttendanceDetail.value.delayed,
    (delayed) => {
        if (delayed === false) {
            studentAttendanceDetail.value.delay = 0;
        }
        if (delayed === true) {
            studentAttendanceDetail.value.delay = 1;
        }
    },
);
watch(
    () => studentAttendanceDetail.value.absent,
    (absent) => {
        if (absent === false) {
            studentAttendanceDetail.value.justification = 0;
        }
        if (absent === true) {
            studentAttendanceDetail.value.justification = 1;
        }
    },
);
</script>
